const isHiddenProperty = (property: string, elementSchema: any = {}) => {
    return elementSchema.hidden?.includes(property);
};
export const sortPropertiesByOrder = (
    properties = {},
    order: string[] = [],
    isIncluded: (property: string) => boolean
) => {
    return order.reduce((obj, key) => {
        if (isIncluded(key) && properties[key] !== undefined) {
            obj[key] = properties[key];
        }
        return obj;
    }, {});
};
export const sortPropertiesByName = (
    properties = {},
    order: string[] = [],
    isIncluded: (property: string) => boolean
) => {
    return Object.keys(properties)
        .sort()
        .reduce((obj, key) => {
            if (!order.includes(key) && properties[key] !== undefined && isIncluded(key)) {
                obj[key] = properties[key];
            }
            return obj;
        }, {});
};
/**
 * The hidden ("More...") section body filters out const discriminants
 * (form-const-*), which never render a control. This returns only the hidden
 * property entries that will actually render, so the caller can suppress an
 * empty "More..." section when the only hidden property is a const discriminant
 * (e.g. the `type` key on a discriminated-union widget branch) — Margot
 * 2026-09-28, operator-task-dashboard-widget-editor-form #5.
 */
export const getRenderableHiddenEntries = (hiddenProperties: Record<string, any> = {}) =>
    Object.entries(hiddenProperties).filter(
        ([, value]: [string, any]) => !value?.element?.startsWith("form-const-")
    );

export const getShownAndHiddenProperties = (elementSchema: any) => {
    const isPropertyHidden = (property: string) => isHiddenProperty(property, elementSchema);

    const shownProperties = {
        ...sortPropertiesByOrder(
            elementSchema.properties,
            elementSchema.order,
            (property) => !isPropertyHidden(property)
        ),
        ...sortPropertiesByName(
            elementSchema.properties,
            elementSchema.order,
            (property) => !isPropertyHidden(property)
        ),
    };

    const hiddenProperties = {
        ...sortPropertiesByOrder(elementSchema.properties, elementSchema.order, (property) =>
            isPropertyHidden(property)
        ),
        ...sortPropertiesByName(elementSchema.properties, elementSchema.order, (property) =>
            isPropertyHidden(property)
        ),
    };

    return { shownProperties, hiddenProperties };
};
